import { TApiResponse } from '@/common/types/response';

import { TBusinessTipState, TParticipantsResponse } from './types';

export function setParticipantsList(state: TBusinessTipState, res: TApiResponse<TParticipantsResponse>) {
  state.participantsList = res.data.items;
}

export function setForeignParticipantsList(state: TBusinessTipState, res: TApiResponse<TParticipantsResponse>) {
  state.foreignParticipantsList = res.data.items;
}
